import Logout from "@mui/icons-material/Logout";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../../slices/userSlice";

const AccountMenu = ({ setShowBasic }) => {
  const [open, setOpen] = React.useState(false);
  const [menuPosition, setMenuPosition] = React.useState(null);
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setMenuPosition({ top: event.clientY, left: event.clientX });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setMenuPosition(null);
    setShowBasic(false);
  };

  const handleLogout = () => {
    dispatch(userLogout());
    handleClose();
  };

  return (
    <>
      <Box
        sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
        className={"ms-3 me-5"}
      >
        <Tooltip title="Профіль">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }} src={user?.avatarUrl}></Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition}
        slotProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0
            }
          }
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small"/>
          </ListItemIcon>
          Вийти
        </MenuItem>
      </Menu>
    </>
  );
};

export default AccountMenu;
